import React, { useState, useEffect } from "react";
import { useTranslation } from "../../i18n/TranslationProvider";

import { Link } from "react-router-dom";

import { Row, Col, Tabs, Tab, OverlayTrigger, Tooltip } from "react-bootstrap";
import ComponentWrapper from "./ComponentWrapper";
// import LineChart from "./LineChart";
import TriggerChart from "./TriggerChart";
import SubmitButton from "../StyledComponents/SubmitButton";
import DoughnutMedical from "../DoughnutMedical";
import DoughnutTrigger from "../DoughnutTrigger";
import LoadingSpinner from "../LoadingSpinner";

import lineChartIcon from "../../images/show_chart.svg";
import barChartIcon from "../../images/bar_chart.svg";
import LineIcon from "../../images/line.svg";
import PieIcon from "../../images/pie.svg";
import FeelingsIcon from "../../images/overall-feelings.svg";
import BarIcon from "../../images/bar.svg";
import TriggerDataIcon from "../../images/trigger-data.svg";

import { getMostRecentFollowUpForm } from "../../api/TBIRequests";

import downloadFollowUpForm from "../../lib/downloadFollowUpForm";

import { parse } from "date-fns";
import getDaysAgo from "../../lib/getDaysAgo";

const DAYS = 30;

const Charts = ({
  topSymptoms,
  data,
  error,
  retry,
  additionalNotes,
  user,
  patient,
}) => {
  const { t, language } = useTranslation();

  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchForm = async (patientId) => {
      try {
        const res = await getMostRecentFollowUpForm({ patientId });
        setFormData(res.data);
      } catch (error) {
        console.error("Error fetching form:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchForm(patient.patientId);
  }, [patient.patientId]);

  const LinkToReport = (title, icon) => (
    <Link to="/charts" className="report-link">
      <img src={icon} alt="icon" className="report-icon" />
      <span style={{ paddingLeft: "0.5rem" }}>{title}</span>
    </Link>
  );

  const lineChartTooltip = (
    <Tooltip id="line-chart-tooltip">{t("dashboard.charts.trendCharts.label")}</Tooltip>
  );

  const barChartTooltip = (
    <Tooltip id="line-chart-tooltip">{t("dashboard.charts.triggerData.label")}</Tooltip>
  );

  const medicalData = data?.filter(
    (obj) =>
      obj.category !== "SDOH" &&
      parse(obj.symptom_date.slice(0, 10), "yyyy-MM-dd", new Date()) >
        getDaysAgo(DAYS)
  );

  const triggerData = data?.filter(
    (obj) =>
      obj.category === "SDOH" &&
      parse(obj.symptom_date.slice(0, 10), "yyyy-MM-dd", new Date()) >
        getDaysAgo(DAYS)
  );

  return (
    <ComponentWrapper>
      <Tabs id="chartTab">
        {error && (
          <div>
            {t("dashboard.charts.error.0")}
            <SubmitButton onClick={retry}>{t("dashboard.charts.error.1")}</SubmitButton>
          </div>
        )}

        <Tab
          eventKey="line"
          title={
            <OverlayTrigger placement="top" overlay={lineChartTooltip}>
              <img src={lineChartIcon} alt="line chart icon" />
            </OverlayTrigger>
          }
        >
          {/* <LineChart
            topSymptoms={topSymptoms}
            data={data}
            additionalNotes={additionalNotes}
            width={100}
            height={Math.max(topSymptoms.length * 45, 300)}
          /> */}
          <Row>
            <Col>
              <h5 className="text-center mt-3">
                {t("dashboard.charts.detailedReports.heading")}
              </h5>

              <ComponentWrapper>
                <DoughnutTrigger
                  data={triggerData}
                  days={30}
                  userName={
                    patient.caregiverName
                      ? patient.caregiverName
                      : patient.firstName
                  }
                />
              </ComponentWrapper>

              <ComponentWrapper>
                <DoughnutMedical
                  data={medicalData}
                  days={30}
                  userName={
                    patient.caregiverName
                      ? patient.caregiverName
                      : patient.firstName
                  }
                />
              </ComponentWrapper>
            </Col>
          </Row>
        </Tab>
        <Tab
          eventKey="bar"
          title={
            <OverlayTrigger placement="top" overlay={barChartTooltip}>
              <img src={barChartIcon} alt="bar chart icon" />
            </OverlayTrigger>
          }
        >
          <TriggerChart data={data} />
        </Tab>
        
        {user.userType === "provider" && (
          <Tab eventKey="Reports" title={t("dashboard.charts.detailedReports.label")}>
            <Row>
              <Col md={6}>
                {LinkToReport(
                  t("dashboard.charts.detailedReports.overallFeelings"),
                  FeelingsIcon
                )}
              </Col>
              <Col md={6}>
                {LinkToReport(t("dashboard.charts.detailedReports.topSymptoms"), BarIcon)}
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                {LinkToReport(t("dashboard.charts.detailedReports.medicalScore"), PieIcon)}
              </Col>
              <Col md={6}>
                {LinkToReport(t("dashboard.charts.detailedReports.topTriggers"), BarIcon)}
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                {LinkToReport(t("dashboard.charts.detailedReports.triggerData"), TriggerDataIcon)}
              </Col>
              <Col md={6}>
                {LinkToReport(t("dashboard.charts.detailedReports.daysInReview"), LineIcon)}
              </Col>
            </Row>
          </Tab>
        )}
        {user.userType === "provider" && (
          <Tab eventKey="FollowUpForm" title={t("dashboard.charts.followUpForm.label")}>
            {loading ? (
              <LoadingSpinner />
            ) : Object.keys(formData).length > 0 ? (
              <div className="followUpFormSummary">
                <Row>
                  <Col>
                    <SubmitButton
                      onClick={() =>
                        downloadFollowUpForm(
                          formData.answers,
                          `${patient.firstName} ${patient.lastName}`,
                          formData.timestamp
                        )
                      }
                    >
                      {t("dashboard.charts.followUpForm.download")}
                    </SubmitButton>
                  </Col>
                  <Col>
                    <p className="completionDate">
                      <b>{t("dashboard.charts.followUpForm.lastCompleted")}</b>{" "}
                      {new Date(formData.timestamp).toLocaleDateString(
                        language, // was hard-coded "en-US"
                        {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        }
                      )}
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <p>
                      <b>{t("dashboard.charts.followUpForm.overallProgramDone")}</b>{" "}
                      {formData.answers.overallProgramPercentage}%
                    </p>
                  </Col>
                  <Col>
                    <p>
                      <b>{t("dashboard.charts.followUpForm.overallProgress")}</b>{" "}
                      {formData.answers.overallProgress}%
                    </p>
                  </Col>
                </Row>
              </div>
            ) : (
              <p className="mt-3 font-weight-normal">
                {t("dashboard.charts.followUpForm.notCompleted")}
              </p>
            )}
          </Tab>
        )}
      </Tabs>
    </ComponentWrapper>
  );
};

export default Charts;